import { render, staticRenderFns } from "./ParticipantsCard.vue?vue&type=template&id=95754a34&"
import script from "./ParticipantsCard.vue?vue&type=script&lang=js&"
export * from "./ParticipantsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports